import { createContext, useContext } from 'react'
import type { User } from '../api/types'

export type Auth = {
  /** The signed-in user, or null when signed out. */
  user: User | null
  /** Everyone on the team (for filters such as "Created by"); empty when signed out. */
  users: User[]
  /** Whether "Reset sample data" / "Load large demo data" are allowed on this server. */
  demoTools: boolean
  /** False until we have asked the server who is signed in. */
  ready: boolean
  /** Throws an ApiError with the server's message if the email or password is wrong. */
  signIn: (email: string, password: string) => Promise<void>
  signOut: () => Promise<void>
  /** Replaces the signed-in user's details (e.g. after changing the password). */
  updateUser: (user: User) => void
  /** Reloads the team list (e.g. after an admin adds someone). */
  reloadUsers: () => Promise<void>
}

// A "context" makes the signed-in user available to every component without passing it down by hand.
export const AuthContext = createContext<Auth | null>(null)

export function useAuth(): Auth {
  const auth = useContext(AuthContext)
  if (!auth) throw new Error('useAuth must be used inside <AuthProvider>')
  return auth
}
